import { LIST_REQUEST_ASYNC, PAGINATE_CHANGE, REPORT_SELECT, URL_STATE_CHANGE } from './constants'

export const fetchIncidentsList = ({ isPolling } = {}) => ({
  type: LIST_REQUEST_ASYNC.INITIATE,
  payload: { isPolling },
})
export const fetchIncidentsListSuccess = (data) => ({
  type: LIST_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchIncidentsListError = (error) => ({
  type: LIST_REQUEST_ASYNC.ERROR,
  error,
})

export const selectReport = (id, type) => ({
  type: REPORT_SELECT,
  payload: { id, type },
})

/**
 * @param {string|null} category
 * @param {{ preserveFilters?: boolean, incidentsRedesign?: boolean }} [options]
 *   Redesign tab switches pass preserveFilters so filter chips / regularFilters survive;
 *   legacy omits it and keeps clearing on tab change.
 *   incidentsRedesign is set only from IncidentsRedesign (ENABLE_INCIDENTS_PAGE_REDESIGN_FF)
 *   so Challenged can default to `date` without changing legacy's `priority`.
 */
export const changeUrlState = (
  category,
  { preserveFilters = false, incidentsRedesign = false } = {}
) => ({
  type: URL_STATE_CHANGE,
  payload: {
    urlState: category,
    preserveFilters: !!preserveFilters,
    incidentsRedesign: !!incidentsRedesign,
  },
})

/** @param {number} [page] Omit for legacy/redesign cursor append; pass 1 to reset; n>1 for redesign offset jump. */
const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })

export default {
  // to props
  fetchIncidentsList,
  selectReport,
  paginateChange,
}
